export default "__VITE_ASSET__BuzQsWau__"